
const theme = {
	colors: {
		red: 'rgba(255,0,0,1)'
	},
}

export default theme;